import { render, staticRenderFns } from "./imageupload.vue?vue&type=template&id=6c49ba33&scoped=true&"
import script from "./imageupload.vue?vue&type=script&lang=js&"
export * from "./imageupload.vue?vue&type=script&lang=js&"
import style0 from "./imageupload.vue?vue&type=style&index=0&id=6c49ba33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c49ba33",
  null
  
)

export default component.exports